"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.chipTypes = exports.chipColors = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

/**
 * @enum {string}
 * @alias Chip.chipColors
 */
var chipColors = {
  /** cyan */
  CYAN: "cyan",

  /** faint-grey */
  FAINTGREY: "faint-grey",

  /** light-grey */
  LIGHTGREY: "light-grey",

  /** dark-grey */
  DARKGREY: "dark-grey",

  /** transparent */
  TRANSPARENT: "transparent",

  /** white */
  WHITE: "white",

  /** red */
  RED: "red",

  /** Midnight */
  DARKBLUE: "dark-blue"
};
/**
 * @enum {string}
 * @alias Chip.chipTypes
 */

exports.chipColors = chipColors;
var chipTypes = {
  /** condensed */
  CONDENSED: "condensed",

  /** count */
  COUNT: "count",

  /** outline */
  OUTLINE: "outline"
};
/**
* @class Chip
* @desc A small text "chip" with a background color.
*
* @param {string} [data-id=chip-component]
*     The data-id of the component.
* @param {string} [className]
*     Class name(s) to add to the top-level container/div.
* @param {Chip.chipColors} [color]
*     The background color of the component.
* @param {(string | object)} [color]
*      An object that holds all of the styling information for the chip color.
* @param {string} [color.background ]
*     Changes the backgroundColor to whatever the user specifies.
* @param {string} [color.text]
*     Changes the text color to whatever the user specifies.
* @param {Chip.chipTypes} [type]
*     The type of the chip.
* @param {boolean} [fullWidth=false]
*     Whether the component takes up the full width of the container.
*/

exports.chipTypes = chipTypes;

var getColor = function getColor() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      background = _ref.background,
      text = _ref.text;

  if (background && text !== undefined) {
    return {
      backgroundColor: background,
      color: text
    };
  } else {
    return null;
  }
};

var isValidColor = function isValidColor(color) {
  var _context;

  return (0, _includes.default)(_context = (0, _values.default)(chipColors)).call(_context, color);
};

function Chip(_ref2) {
  var _classnames;

  var color = _ref2.color,
      children = _ref2.children,
      className = _ref2.className,
      dataId = _ref2["data-id"],
      fullWidth = _ref2.fullWidth,
      type = _ref2.type;
  var colorToUse; // to fix UIP-3495 preserving backward compatibility for default color value

  if (color) {
    colorToUse = color;
  } else if (type === chipTypes.CONDENSED) {
    colorToUse = chipColors.DARKGREY;
  } else {
    colorToUse = chipColors.LIGHTGREY;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: getColor(colorToUse),
    className: (0, _classnames2.default)(className, (_classnames = {
      "chip-component": type !== chipTypes.COUNT,
      "chip-component--condensed": type === chipTypes.CONDENSED,
      "chip-component--outline": type === chipTypes.OUTLINE
    }, (0, _defineProperty2.default)(_classnames, "chip-component--color-".concat(colorToUse), type !== chipTypes.COUNT && isValidColor(colorToUse)), (0, _defineProperty2.default)(_classnames, "chip-component--full-width", fullWidth), (0, _defineProperty2.default)(_classnames, "count", type === chipTypes.COUNT), _classnames)),
    "data-id": dataId
  }, children);
}

Chip.propTypes = {
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  fullWidth: _propTypes.default.bool,
  color: _propTypes.default.oneOfType([_propTypes.default.shape({
    background: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired
  }), _propTypes.default.oneOf((0, _values.default)(chipColors))])
};
Chip.defaultProps = {
  "data-id": "chip-component",
  fullWidth: false
};
var _default = Chip;
exports.default = _default;